import { render, staticRenderFns } from "./BatchDialog.vue?vue&type=template&id=1533eba8&scoped=true&"
import script from "./BatchDialog.vue?vue&type=script&lang=js&"
export * from "./BatchDialog.vue?vue&type=script&lang=js&"
import style0 from "./BatchDialog.vue?vue&type=style&index=0&id=1533eba8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1533eba8",
  null
  
)

export default component.exports